module.exports = __webpack_public_path__ + "static/media/bus_icon.39386dbb.svg";